import L from 'leaflet';
import carIconUrl from '../icons/ic_car.svg';
import * as styles from './styles';

export const EndCarIcon = new L.DivIcon({
  html: `<div class="${styles.endCarIcon}"><img src="${carIconUrl}" /></div>`,
  iconSize: [30, 30],
  iconAnchor: [30, 30],
});
